<template>
  <va-card :title="$t('menu.ranking')">
  <div class="row">
    <div class="flex xs6 sm3">
      <va-select
        :label="$t('forms.inputs.role')"
        v-model="paramRole"
        keyBy="id"
        textBy="name"
        :options="roles"
      />
    </div>

    <div class="flex xs6 sm3">
        <va-button
          medium
          inline
          color="green"
          icon="fa fa-download"
          class="ma-0"
          @click="exportRankingReport()"
        >
          {{ $t('menu.export') }}
        </va-button>
      </div>
    </div>

    <va-data-table
      :fields="fields"
      :data="rankings"
      :per-page="15"
      :loading="loading"
      >
      <template slot="boxes_per_hour" slot-scope="item">
        {{ elapsedBoxesPerHour(item.rowData, now) }}
      </template>

    </va-data-table>
  </va-card>
</template>

<script>

import RankingAPI from '@/services/RankingAPI'
import RoleAPI from '@/services/RoleAPI'
import moment from 'moment'
import { mapState } from "vuex"

export default {
  data () {
    return {
      rankings: [],
      roles: [
        {"id": 1, "name": "Montador"},
        {"id": 2, "name": "Conferente"},
        {"id": 3, "name": "Empilhador"},
        {"id": 4, "name": "Operador LP"},
        {"id": 6, "name": "Transportador"}
      ],
      paramRole: {
        "id": "1",
        "name": "Montador"
      },
      loading: false,
      now: new moment(),
      interval: '',
      filepath: "",
    }
  },

  channels: {
    NeedRefreshMountingTimes: {
      received(data) {
        this.getRanking()
      },
    }
  },

  watch: {
    '$store.state.currentLocality': function() {
      this.getRanking()
    },
    paramRole: function() {
      this.getRanking()
    }
  },

  mounted () {
    this.$cable.subscribe({ channel: 'NeedRefreshMountingTimes', company: this.currentUser.company })
    this.getRanking()
    this.interval = setInterval(() => { this.now = new moment() }, 1000)
  },

  beforeDestroy(){
    window.clearInterval(this.interval);
  },

  methods: {

    exportRankingReport(){
      RankingAPI.exportRankingReport(this.currentLocality.id, this.paramRole.id).then(response => {
        let url = process.env.VUE_APP_API_BASE_URL.replace("api/v1", "")
        let link = document.createElement('a')
        this.filepath = url + response.data.filename
        document.body.appendChild(link)
        link.href=this.filepath

        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
        link.click()
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      });
    },

    async getRanking(){
      this.loading = true

      await RankingAPI.getRanking(this.currentLocality.id, this.paramRole.id).then(response => {
        this.rankings = response.data.rankings
        this.loading = false
      })
    },

    async getRoles() {
      await RoleAPI.getRoles().then(response => {
        this.roles = response.data.roles
      })
    },

    elapsedTime: function(first_load_sequenced, now){
      var first_load_sequenced = moment(first_load_sequenced)
      var duration = moment.duration(now.diff(first_load_sequenced))

      var hours = duration._data.hours === 1 ? `${duration._data.hours} ${this.$t('tables.workTime.hour')}` : `${duration._data.hours} ${this.$t('tables.workTime.hours')}`
      var minutes = duration._data.minutes === 1 ? `${duration._data.minutes} ${this.$t('tables.workTime.minute')}` : `${duration._data.minutes} ${this.$t('tables.workTime.minutes')}`

      if (duration._data.hours > 0){
        return `${hours}, ${minutes} ${this.$t('tables.workTime.and')} ${duration._data.seconds} ${this.$t('tables.workTime.seconds')}`
      } else {
        return `${minutes} ${this.$t('tables.workTime.and')} ${duration._data.seconds} ${this.$t('tables.workTime.seconds')}`
      }
    },

    elapsedBoxesPerHour: function(item, now){
      var time_diff = (now.diff(item.operation_start)) / 3600000
      var boxes_per_hour = (item.boxes_mounted / time_diff).toFixed(2)
      return boxes_per_hour
    },
  },

  computed: {
    ...mapState(['currentUser', 'currentLocality']),

    fields () {
      return [{
        name: 'position',
        title: this.$t('tables.ranking.position'),
      },
      {
        name: 'user_name',
        title: this.$t('tables.orders.user'),
      },
      {
        name: 'login',
        title: this.$t('tables.ranking.login'),
      },
      {
        name: '__slot:boxes_per_hour',
        title: this.$t('tables.works.box/hour'),
      },
      {
        name: 'boxes_mounted',
        title: this.$t('tables.ranking.quantity_box'),
      },
      {
        name: 'orders_mounted',
        title: this.$t('tables.ranking.quantity_pallet'),
      },
      {
        name: 'errors',
        title: this.$t('tables.ranking.quantity_error'),
      }
      ]
    }
  }
}
</script>
